module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-bottom-386229f98722eff34333d57e3c58fff4.svg";